"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSafeContext = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
var react_1 = __importDefault(require("react"));
/**
 * Wrapper hook around `useContext` that throws an error if the context is not provided.
 * @param context Context to use. Must have a `displayName` for useful errors.
 */
var useSafeContext = function (context) {
    var value = react_1.default.useContext(context);
    if (!value) {
        throw new Error("".concat(context.displayName, " is undefined"));
    }
    return value; // eslint-disable-line @typescript-eslint/no-non-null-assertion -- we already checked for undefined
};
exports.useSafeContext = useSafeContext;
